import React from "react";

/* Directory listing — a building with windows. */
export const BuildingIcon = ({ size = 20, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    <rect x="5" y="3" width="14" height="18" rx="2" stroke="currentColor" strokeWidth="1.6" />
    <path
      d="M9 7.5h2M13 7.5h2M9 11.5h2M13 11.5h2M9 15.5h6"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
);

export default BuildingIcon;
